import React from 'react'
import { useTranslation } from 'react-i18next'
import { getScoreColor } from '@popety-io/utils'
import {
  HeroBar,
  ScoresRow,
  ScoreMiniCard,
  ScoreMiniValue,
  ScoreMiniMax,
  ScoreMiniBar,
  ScoreMiniFill,
  ScoreMiniLabel,
} from './SummaryDashboard.styles'

export const HeroSection: React.FC<{
  land: any
  onNavigate?: (tab: string) => void
}> = ({ land, onNavigate }) => {
  const { t } = useTranslation()

  const scores = [
    {
      label: t('landAnalysis.scoreOverview.underExploitedScore'),
      value: land.under_exploited_score || 0,
      tab: 'zoning_data',
    },
    {
      label: t('landAnalysis.scoreOverview.legacyScore'),
      value: land.existing_score || 0,
      tab: 'buildings',
    },
    {
      label: t('landAnalysis.scoreOverview.livabilityScore'),
      value: land.livability_score || 0,
      tab: 'amenities',
    },
    {
      label: t('landAnalysis.scoreOverview.geometryScore'),
      value: land.geo_shape_score || 0,
      tab: 'geo',
    },
  ]

  return (
    <HeroBar>
      <ScoresRow>
        {scores.map((score, i) => {
          const color = getScoreColor(score.value, 100)
          const clickable = !!(onNavigate && score.tab)
          return (
            <ScoreMiniCard
              key={i}
              $clickable={clickable}
              onClick={clickable ? () => onNavigate!(score.tab!) : undefined}
            >
              <ScoreMiniValue $color={color}>{score.value}</ScoreMiniValue>
              <ScoreMiniMax>/100</ScoreMiniMax>
              <ScoreMiniBar>
                <ScoreMiniFill
                  $color={color}
                  style={{ width: `${score.value}%` }}
                />
              </ScoreMiniBar>
              <ScoreMiniLabel>{score.label}</ScoreMiniLabel>
            </ScoreMiniCard>
          )
        })}
      </ScoresRow>
    </HeroBar>
  )
}
